import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ShoppingCartProvider } from "./components/_default/context/ShoppingCartContext"
import store from "./store/store"
import Redirect from "./components/_default/utilities/Redirect"
import TagManager from 'react-gtm-module'
// Pages
import Webpage1Avaleht from "./pages/Webpage1Avaleht";
import Webpage2Lehte_ei_leitud from "./pages/Webpage2Lehte_ei_leitud";
import Webpage3K__psiste_poliitika from "./pages/Webpage3K__psiste_poliitika";
import Webpage4K__psis from "./pages/Webpage4K__psis";

var baseURL = 'https://madlivali.kassahaldus.ee/webstoreApi';
var axiosHeaders = {
    Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIzIiwianRpIjoiMTkzZmFkNzc1MmI0ZDE2ZmY3YjlhOTI2NzAyN2MwOWQyMjg3YTg3M2ZmZGFkYmE4NTAxY2E0YjQyYTUyYjBjZWI1N2RjMzkwMjFmZjI5YWYiLCJpYXQiOjE3ODg4MzQ0NjAuNjk4NTUsIm5iZiI6MTc4ODgzNDQ2MC42OTg1NTMsImV4cCI6MTc4ODkyMDg2MC42OTU1MjMsInN1YiI6IjgiLCJzY29wZXMiOltdfQ.YX7bBF1Fvv5Zhbb0FEFzA2dKJ2vCc_yi4Lc8bz4vDE7cYz_wWPTx8lACxyRioIoVO3SwNo-5Y9aFmCgqzgMsRkptKSMs8CyIRoOJoCJ30ZhHDx9F52hQjqiY6j0Eks5s_Kc78BOJAQ6CnOShHg5cT6dRfrOPK-NUpoOLBUhLkuhjqMbPYsshyRJvk1hNN66Rm4MrJMQVT7gl-xSFEyAyDsfsvA9pYLJbUR5b-5NFM2ZgWfCt2ZoCEC4eTltcydXO82dsxoEbqnDRkBahgshlR0HLBFQ3q7IPyVXJb49wd3Kr6k9xSKBuCvu_R1GooPLKSqz6KPnCvVLqM5VfnqcR1JMaJTg-FE3rcVjcv71Cy0F7n0ze6l8UuAhZAYtXQ0F7uMoacLl0c8rOfPOAvQxl5RKPzPTTVKfgvohaa0OlO7jpkvH_M6AS1DVLjBmXN8vaFggdzsst_WOgeAiNI_uynOqksmRVtaYMz_CWKzwzOTmnyLUPxG2nWnwNfJfiYzhn-QuN4AwHY6OqldpIyK9rVilnSrajdA1bREH5ldoHfonHwGMWg5_cu1Lc7LnV8wSSSyz49TVzc66TqGa7Sjxpu_6TXOlEuWUY70Jc6JlzFLhmWaOpVhsw2UHgKBrB39XAtBymnCXxEIPnZZjifs9vPcqI8HzJbB8BrLgytIpB-Ic',
    'Access-api-key': "eyJpdiI6IkljNzZocS9FdE8vbmRJKzhRN1VGY3c9PSIsInZhbHVlIjoiZkdRZTk3czV4M2MwRlBpRE83Q2Zndz09IiwibWFjIjoiM2I3MzdlMTVjMjcyMTE3YzZjMjgzMWViZmIxNzhhMjdkZTM4ZTQ4OTdiM2UxYmYzMzAwMzc1YzYxYzUxYzU4YyIsInRhZyI6IiJ9",
    'Access-api-id': "eyJpdiI6InU4K05LV1ZVejVmcUx2alRacWk2T1E9PSIsInZhbHVlIjoibUZaRUtpSXRBTHVVVGhnN1hBc2RlUT09IiwibWFjIjoiOGIzN2I3NGZlOWNmZWIwYjA2ZjVkZjc4OGIyYWJiZjI0OWFmNjdjYTc2MTZjNGEwOGZhYjUxZGQ2ODRkYjQyNCIsInRhZyI6IiJ9",
    'Access-Control-Allow-Origin': "*"
 };


window.axios = require('axios').create({
  baseURL: baseURL,
  headers: axiosHeaders
});
const tagManagerArgs = {
    gtmId: "GTM-KWH9BQ8"
}
TagManager.initialize(tagManagerArgs)
    
export default function App() {
    window.dataLayer.push({
        event: 'pageview'
    });
    return (
        <Provider store={store}>
            <ShoppingCartProvider>
                <BrowserRouter basename="/">
                    <Routes>
                                                                                            <Route path="/et" element={<Webpage1Avaleht />} exact />;
                        
                                                <Route path="/et/" element={<Webpage1Avaleht />} exact />;
                                                                                                                                                                                            
                                                                                                                <Route path="/et/*" element={<Webpage2Lehte_ei_leitud />} exact />;
                                                                                                                                                <Route path="/en/*" element={<Webpage2Lehte_ei_leitud />} exact />;
                                                                                
                        <Route path="*" element={<Webpage2Lehte_ei_leitud />} exact />;
                                                                                                                    <Route path="/et/kupsiste-poliitika" element={<Webpage3K__psiste_poliitika />} exact />;
                        
                                                                                                                                                                    <Route path="/et/templates" element={<Webpage4K__psis />} exact />;
                        
                                                                                                                
                                                            </Routes>
                </BrowserRouter>
            </ShoppingCartProvider>
        </Provider>
    );
}